<script>
export default {
  name: "DisposalRecyclingNoteDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      internalNote: '',
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.internalNote = this.note || ''
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },
    applyNote() {
      this.$emit('apply', this.internalNote)
      this.closeDialog()
    },
  },
}
</script>

<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h6">備考追加</span>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="internalNote"
              label="備考"
              outlined
              dense
              hide-details="auto"
              placeholder="備考を入力してください"
              maxlength="25"
              persistent-placeholder
            >
              <template v-slot:label>
                <span>備考</span>
                <span class="ml-1">
                  ({{ internalNote?.length || 0 }} / 25)
                </span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeDialog"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="primary"
          @click="applyNote"
        >
          反映
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
</style>
